var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3414,
    y: 0.0269404,
    width: 1.56255,
    height: 4.7954,
    rx: 0.781273,
    fill: "#00B4FD",
    stroke: "#00B4FD",
    strokeWidth: 0.0538809
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1299,
    y: 3.00148,
    width: 1.56255,
    height: 4.7954,
    rx: 0.781273,
    transform: "rotate(44.9612 20.1299 3.00148)",
    fill: "#00B4FD",
    stroke: "#00B4FD",
    strokeWidth: 0.0538809
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2456,
    y: 11.316,
    width: 1.56255,
    height: 4.7954,
    rx: 0.781273,
    transform: "rotate(89.9224 24.2456 11.316)",
    fill: "#00B4FD",
    stroke: "#00B4FD",
    strokeWidth: 0.0538809
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82173,
    y: 11.316,
    width: 1.56255,
    height: 4.7954,
    rx: 0.781273,
    transform: "rotate(89.9224 4.82173 11.316)",
    fill: "#00B4FD",
    stroke: "#00B4FD",
    strokeWidth: 0.0538809
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.50292,
    y: 6.38558,
    width: 1.56255,
    height: 4.7954,
    rx: 0.781273,
    transform: "rotate(134.884 7.50292 6.38558)",
    fill: "#00B4FD",
    stroke: "#00B4FD",
    strokeWidth: 0.0538809
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79488 18.7776H19.5044C20.6798 18.7776 21.6327 19.7304 21.6327 20.9058V24.6506H2.66659V20.9058C2.66659 19.7304 3.61946 18.7776 4.79488 18.7776Z",
    fill: "#00B4FD",
    stroke: "#00B4FD",
    strokeWidth: 0.0538809
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8985 12.2581V18.7238H6.36795V12.2581C6.36795 9.07402 8.94914 6.49283 12.1332 6.49283C15.3173 6.49283 17.8985 9.07402 17.8985 12.2581Z",
    stroke: "#00B4FD",
    strokeWidth: 1.72419
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.cf86c5532e0c40e4f0e721a910961680.svg";
export { ForwardRef as ReactComponent };